import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const registeredUserConfirmationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("registered/user/confirmation"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/registered/user/confirmation"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
